var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg08GulpAiPoints(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 7.31445C20.799 7.31445 24.6856 11.2011 24.6856 16C24.6856 20.7989 20.799 24.6855 16.0001 24.6855C11.2011 24.6855 7.31452 20.7989 7.31452 16C7.31454 11.2011 11.2012 7.31446 16.0001 7.31445ZM16.3702 12.5898C16.2308 12.255 15.7683 12.2549 15.629 12.5898L15.254 13.4941C14.93 14.2746 14.3253 14.8974 13.5665 15.2344L12.5801 15.6729C12.2561 15.8167 12.2561 16.2877 12.5801 16.4316L13.5987 16.8838C14.3383 17.2125 14.9321 17.8137 15.2618 18.5684L15.6319 19.417C15.7744 19.7427 16.2248 19.7427 16.3673 19.417L16.7374 18.5684C17.0671 17.8132 17.6608 17.2129 18.4014 16.8848L19.42 16.4326C19.744 16.2887 19.744 15.8167 19.42 15.6729L18.4327 15.2344C17.6735 14.8975 17.0702 14.2745 16.7462 13.4941L16.3702 12.5898Z",
    fill: "#FFC020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 4.02637C22.6119 4.02637 27.9736 9.38814 27.9736 16C27.9736 22.6119 22.6119 27.9736 16 27.9736C9.38814 27.9736 4.02637 22.6119 4.02637 16C4.02637 9.38814 9.38814 4.02637 16 4.02637ZM16 5.59639C21.7469 5.59639 26.4036 10.2531 26.4036 16C26.4036 21.7469 21.7469 26.4036 16 26.4036C10.2531 26.4036 5.59639 21.7469 5.59639 16C5.59639 10.2531 10.2531 5.59639 16 5.59639Z",
    fill: "#FFC020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg08GulpAiPoints);
export default __webpack_public_path__ + "static/media/08_gulp_ai_points.6ab55d65061e525f521f79eb4b17dac6.svg";
export { ForwardRef as ReactComponent };